import React, { Component } from "react";
import styled from "styled-components";
import { colors } from "../../resources/ThemeColors";
import SearchCard from "../../components/SearchCard";
import EditIcon from "../../resources/edit.png";
import SearchIcon from "../../resources/search.png";
import CalendarIcon from "../../resources/calendar.png";
import { breakpoints } from "../../Media";
import SalonImage from "../../resources/salon.jpg";

class Landing extends Component {
  render() {
    return (
      <MainDiv>
        <TopDiv>
          <SearchCardDiv>
            <SearchCard />
          </SearchCardDiv>
        </TopDiv>
        <HowItWorksDiv>
          <HowItWorksTitleDiv>
            <HowItWorksTitle>How It Works</HowItWorksTitle>
          </HowItWorksTitleDiv>
          <HowItWorksSection>
            <ItemDiv>
              <ItemImageDiv>
                <Image src={EditIcon} alt=""></Image>
              </ItemImageDiv>
              <DescriptionDiv>
                <Description>Create an account.</Description>
              </DescriptionDiv>
            </ItemDiv>
            <ItemDiv>
              <ItemImageDiv>
                <Image src={SearchIcon} alt=""></Image>
              </ItemImageDiv>
              <DescriptionDiv>
                <Description>Search for a service.</Description>
              </DescriptionDiv>
            </ItemDiv>
            <ItemDiv>
              <ItemImageDiv>
                <Image src={CalendarIcon} alt=""></Image>
              </ItemImageDiv>
              <DescriptionDiv>
                <Description>
                  Make an appointment at your own convenience.
                </Description>
              </DescriptionDiv>
            </ItemDiv>
          </HowItWorksSection>
        </HowItWorksDiv>
        <JoinQDiv>
          <JoinQTitle>Join The Q</JoinQTitle>
          <JoinQDesc>
            Are you a personal care services provider? HairQ will help you list
            your services and reach more clients while managing appointments
            effectively.
          </JoinQDesc>
          <JoinQButton as="a" href="https://admin.hairq.co.uk/" target="_blank">
            Join the Q
          </JoinQButton>
        </JoinQDiv>
      </MainDiv>
    );
  }
}

export default Landing;

const MainDiv = styled.div`
  height: auto;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  padding-bottom: 3em;
  background-color: ${colors.main};
  z-index: -1;
`;

const TopDiv = styled.div`
  height: 90vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(${SalonImage});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  z-index: 0;
`;

const HowItWorksDiv = styled.div`
  width: 90%;
  height: 30vh;
  margin-top: -2.5em;
  border-radius: 12px;
  border: 1.5px solid gray;
  background-color: white;
  z-index: 0;

  @media (max-width: ${breakpoints.mobileMin}) {
    height: auto;
    margin-top: -5em;
    width: 75%;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
  }
`;

const HowItWorksTitleDiv = styled.div`
  height: 20%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px 12px 0 0;
`;

const HowItWorksTitle = styled.h2`
  font-size: 1.6em;
  font-weight: 700;
  margin-top: 1em;
  color: ${colors.main};
  @media (max-width: ${breakpoints.mobileMin}) {
    font-size: 1.3em;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
  }
`;

const HowItWorksSection = styled.div`
  height: 80%;
  border-radius: 0 0 12px 12px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-evenly;

  @media (max-width: ${breakpoints.mobileMin}) {
    height: auto;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
  }
`;

const ItemDiv = styled.div`
  height: 75%;
  width: 30%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: space-evenly;

  @media (max-width: ${breakpoints.mobileMin}) {
    width: 80%;
    margin-top: 1em;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
  }
`;

const ItemImageDiv = styled.div`
  height: 22%;
  width: 22%;
  @media (max-width: ${breakpoints.mobileMin}) {
    height: 18%;
    width: 18%;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
  }
`;

const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
`;

const DescriptionDiv = styled.div`
  height: 50%;
  width: 90%;
`;

const Description = styled.p`
  font-size: 1.1em;
  font-weight: 400;
  font-style: normal;
  line-height: 1.1;
  color: ${colors.main};
  text-align: center;

  @media (max-width: ${breakpoints.mobileMin}) {
    font-size: 1em;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
  }
`;

const SearchCardDiv = styled.div`
  position: absolute;
  top: 15%;
  left: 50%;
  @media (max-width: ${breakpoints.mobileMin}) {
    top: 10%;
    left: 5%;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    left: 25%;
  }
`;

const JoinQDiv = styled.div`
  width: 90%;
  height: auto;
  margin-top: 2em;
  border-radius: 12px;
  border: 1.5px solid gray;
  background-color: white;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-start;
  padding: 1em 0em 1em 0em;

  @media (max-width: ${breakpoints.mobileMin}) {
    height: auto;
    width: 75%;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
  }
`;

const JoinQTitle = styled.h2`
  font-size: 1.4em;
  font-weight: 700;
  color: ${colors.main};
`;

const JoinQDesc = styled.p`
  width: 85%;
  font-size: 1.1em;
  font-weight: 300;
  color: ${colors.main};
  margin-top: 0.5em;
  text-align: center;
  letter-spacing: 1.1;
  line-height: 1.3;
`;

const JoinQButton = styled.button`
  background-color: ${colors.main};
  color: white;
  width: 25%;
  height: 3em;
  border-radius: 8px;
  border: none;
  margin-top: 1em;
  font-size: 0.9em;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  letter-spacing: 1.3;

  @media (max-width: ${breakpoints.mobileMin}) {
    width: 40%;
  }
`;
